import { useEffect, useRef } from 'react';
import { animated, useSpring, useTransition } from '@react-spring/web';
import Badge from 'components/generic/badge/Badge';
import useBasketQuantity from 'hooks/basket/useBasketQuantity';

const AnimatedBadge = animated<any>(Badge);

export default function BasketBadge(props) {
    const [value] = useBasketQuantity();
    const initialAnimationRan = useRef<boolean>(false);

    const isActive = !!value;

    const transitions = useTransition(isActive, {
        from: { scale: 0 },
        enter: { scale: 1 },
        leave: { scale: 0 },
        onRest: () => {
            initialAnimationRan.current = true;
        }
    });

    const [springProps, api] = useSpring(() => ({
        y: 0
    }));

    useEffect(() => {
        if (initialAnimationRan.current) {
            api.start({ from: { y: 0 }, to: { y: 100 }, config: { tension: 150, friction: 40 } });
        }
    }, [value]);

    return transitions(
        ({ scale }, item) =>
            item && (
                <AnimatedBadge
                    {...props}
                    style={{
                        scale,
                        y: springProps.y.to({
                            range: [0, 50, 100],
                            output: [0, -10, 0]
                        })
                    }}
                    size="small"
                >
                    {value}
                </AnimatedBadge>
            )
    );
}
